import { Column, ModelBase } from 'loca-boot-core'

// ares 资源数据模型
export class AresPermissionModel extends ModelBase {
  @Column()
  public id!: number

  @Column({ default: '' }) // e.g. 资源管理模块权限管理（资源列表、详情等）
  public name!: string

  @Column()
  public priority?: number

  @Column({ default: '' }) // 'page' | 'menu' | '功能'
  public type!: string

  @Column() // e.g. mfe:swap:resource
  public identifier!: string

  @Column({ default: '' }) // 'enable' | 'disable'
  public status!: string

  @Column({ name: 'children', childType: AresPermissionModel })
  public children?: AresPermissionModel[]
}

// ares 属性数据模型
export class AresConditionModel extends ModelBase {
  @Column()
  public id!: number

  @Column({ default: '' }) // 'level' | 'location'
  public type!: string

  @Column()
  public value!: string

  @Column({ default: '' })
  public remark!: string
}
